import { autoMount } from '../../../utils/autoMount';
import { BrandDetail } from '../../../components/pages/brandDetail';

autoMount({ BrandDetail });
